import styled from "styled-components";

import Search from "../components/Search";
import Filter from "../components/Filter";
import { useEffect, useState } from "react";
import CountryCard from "../components/CountryCard";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";

const StyledHome = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Menu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3rem 10rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const CountryCardsContainer = styled.div`
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 4rem;
  margin: 0 auto;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

function Home() {
  const [countries, setCountries] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [regionFilter, setRegionFilter] = useState("All");
  const [sortFilter, setSortFilter] = useState("Country Name");

  useEffect(() => {
    setLoading(true);
    try {
      fetch("https://restcountries.com/v3.1/all")
        .then((response) => response.json())
        .then((data) => {
          setCountries(data);
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }, []);

  function sortCountries(countries) {
    let sortedCountries = [...countries];

    switch (sortFilter) {
      case "Country Name":
        return sortedCountries.sort((a, b) =>
          a.name.common.localeCompare(b.name.common)
        );
      case "Region":
        return sortedCountries.sort((a, b) => a.region.localeCompare(b.region));
      case "Population":
        return sortedCountries.sort((a, b) => b.population - a.population);
      default:
        return sortedCountries;
    }
  }

  function handleSearch(e) {
    setSearch(e.target.value);
  }

  function handleRegionChange(e) {
    setRegionFilter(e.target.value);
  }

  function handleSortChange(e) {
    setSortFilter(e.target.value);
  }

  function formatPopulation(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B"; // For numbers in billions
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M"; // For numbers in millions
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K"; // For numbers in thousands
    } else {
      return num; // If number is smaller than 1000
    }
  }

  return (
    <StyledHome>
      <Menu>
        <Search onChange={handleSearch} />
        <Filters>
          <Filter
            label="Region:"
            options={["All", "Africa", "Americas", "Asia", "Europe", "Oceania"]}
            onChange={handleRegionChange}
          />
          <Filter
            label="Filtered by:"
            options={["Country Name", "Region", "Population"]}
            onChange={handleSortChange}
          />
        </Filters>
      </Menu>

      <CountryCardsContainer>
        {loading ? (
          <Loader />
        ) : (
          sortCountries(
            countries
              .filter(
                (country) =>
                  regionFilter === "All" || country.region === regionFilter
              )
              .filter(
                (country) =>
                  !search ||
                  country.name.official
                    .toLowerCase()
                    .includes(search.toLowerCase())
              )
          ).map((country) => (
            <StyledLink to={`/country-info/${country.cca3}`} key={country.cca3}>
              <CountryCard
                key={country.name.common}
                name={country.name.common}
                flag={country.flags.png}
                population={formatPopulation(country.population)}
                region={country.region}
                capital={country.capital}
                subregion={country.subregion}
              />
            </StyledLink>
          ))
        )}
      </CountryCardsContainer>
    </StyledHome>
  );
}

export default Home;
